module.exports = __webpack_public_path__ + "img/Weitverkehrstrupp.ac2ddd06.svg";